const mapReturnInstruction = set => ({
  id: set.id,
  internal_id: set.internal_id,
  name: set.name,
  type: set.type,
  steps: set.steps,
})

export const transformResponseReturnInstructions = response => ({
  results: response.results.map(mapReturnInstruction),
  count: response.count,
  next: response.next,
})
